import { Sparkles } from "lucide-react";

/** Highlight banner shown above the ShareButtons row when the student just
 * hit a milestone worth celebrating (90%+ on mock exam, perfect score on a
 * module exam, gold badge unlock, etc.).
 *
 * Visual: animated gradient + sparkles to draw the eye toward the share
 * buttons below — converts more outbound shares.
 */
export default function CelebrateShareBanner({ title, subtitle, testId = "celebrate-share-banner" }) {
  return (
    <div
      className="mb-3 px-3 py-2.5 rounded-lg bg-gradient-to-r from-amber-500 via-orange-500 to-rose-500 text-white flex items-center gap-2.5 shadow-md ring-2 ring-amber-200 ring-offset-2 ring-offset-white"
      data-testid={testId}
    >
      <Sparkles className="w-4 h-4 shrink-0" />
      <div className="min-w-0">
        <div className="text-sm font-bold leading-tight">{title}</div>
        {subtitle && (
          <div className="text-[11px] opacity-95 mt-0.5 leading-snug">{subtitle}</div>
        )}
      </div>
    </div>
  );
}
